export default "__VITE_ASSET__Bhp2McmO__"